export default "__VITE_ASSET__BKtH2HfF__"